<template>
  <font-awesome-icon :icon="['fa-solid', icon]" />
</template>
<script>
const icons = {
  1: "fa-check-to-slot",
  2: "fa-scale-balanced",
  3: "fa-globe",
  4: "fa-shield",
  5: "fa-earth-europe",
  6: "fa-gavel",
  7: "fa-coins",
  8: "fa-building-columns",
  9: "fa-handshake",
  10: "fa-map-location-dot",
  11: "fa-book",
  12: "fa-staff-snake",
  13: "fa-house",
  14: "fa-school",
  15: "fa-photo-film",
  16: "fa-microscope",
  17: "fa-truck",
  18: "fa-tree",
  19: "fa-tractor",
  20: "fa-lightbulb",
  21: "fa-sitemap"
};

export default {
  name: "VoteItemTag",
  components: {},
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return icons[this.topic.id] || "fa-circle";
    }
  }
};
</script>
